module.exports = __webpack_public_path__ + "img/pass.79714034.svg";